module.exports = __webpack_public_path__ + "static/media/generationenbund-bgl.959e86c5.png";